module.exports = "<ui-view id=\"session\"></ui-view>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sesion/template.html
// module id = 2089
// module chunks = 0